import React from 'react';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import { connect } from 'react-redux';

// Components
import PressFull from './press-full';
import { avangaEncodeURI, valideCSSName } from './../helpers';

// 3rd Party
import Collapse from 'react-collapse';
import ExecutionEnvironment from 'exenv';
import { StickyContainer, Sticky } from 'react-sticky';

const mapStateToProps = state => ({
  headerIsPinned: state.headerIsPinned,
  isMobile: state.isMobile
});

class Press extends React.Component {
  constructor(props) {
    super(props);

    let backgroundVideo = false,
      itemsPerRow = 4,
      sectionStyle = {};

    const isMobile = window.innerWidth <= 640;

    if (!isMobile) {
      if (window.innerWidth > 888) {
        itemsPerRow = 5;
      }
    }

    this.resizeHandler = this.resizeHandler.bind(this);

    if (props.content.teaser_image) {
      sectionStyle = { backgroundImage: `url('${require(`../../../public/content/assets/${props.content.teaser_image}`)}')` };
    }

    if (props.content.teaser_video) {
      backgroundVideo = `/public/content/assets/${props.content.teaser_video}`;
    }

    this.state = {
      backgroundVideo,
      isMobile,
      itemsPerRow,
      sectionStyle,
      stickyMarginTop: -25,
      teaserTextUrl: `/${props.content.heading.replace(/\s/g, '-').toLowerCase()}`
    };
  }

  resizeHandler() {
    const isMobile = window.innerWidth <= 640;

    let itemsPerRow = 4;

    if (!isMobile) {
      if (window.innerWidth > 888) {
        itemsPerRow = 5;
      }
    }

    if (this.state.isMobile !== isMobile || this.state.itemsPerRow !== itemsPerRow) {
      this.setState({
        isMobile,
        itemsPerRow
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.headerIsPinned !== nextProps.headerIsPinned) {
      if (nextProps.headerIsPinned) {
        if (this.state.isMobile) {
          this.setState({ stickyMarginTop: 80 });
        } else {
          this.setState({ stickyMarginTop: 80 });
        }
      } else {
        this.setState({ stickyMarginTop: -25 });
      }
    }
  }

  render() {
    return (
      <Router>
        <section className="teaser-text press">
          <Route path={this.state.teaserTextUrl} children={({ match }) => (
            <div>
              <StickyContainer>
              <div className="teaser-wrap" style={this.state.sectionStyle}>
                {typeof this.state.backgroundVideo === 'string' && !this.props.isMobile &&
                  <div className="video-wrap">
                    <video autoPlay loop>
                      <source src={this.state.backgroundVideo} type="video/mp4" />
                      Your browser does not support HTML5 video.
                    </video>
                  </div>
                }
                <div className="wrap">
                  <h2>{this.props.content.heading}</h2>
                  <div className="teaser-text">
                    <p dangerouslySetInnerHTML={{ __html: this.props.content.teaser_text }} />
                  </div>
                  <Sticky isActive={match} topOffset={25} stickyStyle={{ marginTop: this.state.stickyMarginTop }}>
                    <Link to={match ? '/' : this.state.teaserTextUrl} className={match ? 'read-more active' : 'read-more'}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 100 100">
                        <g>
                          <path d="M50,5A45,45,0,1,0,95,50,45,45,0,0,0,50,5ZM77,54.75H54.75V77a4.76,4.76,0,1,1-9.5,0V54.75H23a4.76,4.76,0,1,1,0-9.5H45.25V23a4.76,4.76,0,1,1,9.5,0V45.25H77a4.76,4.76,0,1,1,0,9.5Z"/>
                        </g>
                      </svg>
                    </Link>
                  </Sticky>
                </div>
              </div>

              <Collapse isOpened={match} className="full-text-press">
                {this.state.isMobile ? (
                  <div className="wrap-press mobile">
                    {this.props.content.press_items.map((item, index) =>
                      <article key={index} className="press-article">
                        <div className="hover">
                          <h2>{item.heading}</h2>
                          <div className="subline" dangerouslySetInnerHTML={{ __html: item.subline }} />
                          <div className="download-wrap">
                            <div className="file-name">{item.file}</div>
                            <a href={`/public/content/assets/${item.file}`}>Artikel anzeigen</a>
                          </div>
                        </div>
                      </article>
                    )}
                  </div>
                ) : (
                  <Router>
                    <div className="wrap-press desktop">
                      {this.props.content.press_items.map((item, index) => [
                        <article key={index} className="press-article">
                          <Link to={`/presse/${avangaEncodeURI(item.subline_hover)}`}>
                            <div className="teaser-image-background" style={{ backgroundImage: `url('${require(`../../../public/content/assets/${item.teaser_image}`)}')` }} />
                            <div className="hover">
                              <h2>{item.date}</h2>
                              <div className="subline" dangerouslySetInnerHTML={{ __html: item.subline_hover }} />
                              <Link to={`/presse/${avangaEncodeURI(item.subline_hover)}`} className="read-more" />
                            </div>
                          </Link>
                        </article>,
                        <Route path={`/presse/${avangaEncodeURI(item.subline_hover)}`} children={({ matchPressArticle }) => (
                          <PressFull itemsPerRow={this.state.itemsPerRow} index={index} match={matchPressArticle} items={this.props.content.press_items} />
                        )} />
                      ])}
                    </div>
                  </Router>
                )}
              </Collapse>
              </StickyContainer>
            </div>
          )} />
        </section>
      </Router>
    );
  }

  componentDidMount() {
    window.addEventListener('resize', this.resizeHandler);

    // Scroll Restoration
    const timeoutBeforeScroll = 350;

    if (window.location.pathname.includes('/presse/') && !this.state.isMobile) {
      const item = window.location.pathname.replace('/presse/', ''),
        sectionToScroll = document.querySelector(`.press-article-full.${valideCSSName(item)}`);

      setTimeout(() => {
        if (history && 'scrollRestoration' in history) {
          history.scrollRestoration = 'manual';
        }

        window.scrollTo(0, sectionToScroll.offsetTop);
      }, timeoutBeforeScroll);
    } else if (window.location.pathname.includes('/presse/') && this.state.isMobile) {
      const sectionToScroll = document.querySelector('section.teaser-text.press');

      setTimeout(() => {
        if (history && 'scrollRestoration' in history) {
          history.scrollRestoration = 'manual';
        }

        window.scrollTo(0, sectionToScroll.offsetTop);
      }, timeoutBeforeScroll);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeHandler);
  }
}

export default connect(mapStateToProps)(Press);


// WEBPACK FOOTER //
// ./src/sections/press/press.jsx